import { render } from "./RcuCheck.vue?vue&type=template&id=3bdca2d2&scoped=true"
import script from "./RcuCheck.vue?vue&type=script&lang=js"
export * from "./RcuCheck.vue?vue&type=script&lang=js"

import "./RcuCheck.vue?vue&type=style&index=0&id=3bdca2d2&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdca2d2"]])

export default __exports__